import React from "react";
import useBreakpoint from "./useBreakpoint";

export default function withBreakpoint(Component: React.ComponentType<typeof withBreakpoint>) {
    return (props: any) => {
        const breakpoint = useBreakpoint();
        return <Component breakpoint={breakpoint} {...props} />;
    };
};